import i1 from "assets/img/posts/i1.jpg";
import { useDispatch } from "react-redux";
import { openLightBox } from "services/redux/lightbox/lightbox";
import { AppDispatch } from "services/redux/store";

const PostMedia1 = () => {
    const dispatch = useDispatch<AppDispatch>();
    // single image preview
    return (
        <div className="post-image cursor-pointer">
            <img
                // src="https://via.placeholder.com/1600x900"
                src={i1}
                // data-demo-src="assets/img/demo/unsplash/1.jpg"
                alt=""
                onClick={() => dispatch(openLightBox())}
            />
        </div>
    );
};

export default PostMedia1;
